var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('origins-form',{attrs:{"id":"0","distribution-id":_vm.distributionId},on:{"submit":_vm.addOrigin,"close":_vm.onClose}})}
var staticRenderFns = []

export { render, staticRenderFns }